import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the withdrawal request view.
 */
export default class recordTableWithdrawalRequestView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const vthis = this; // Reference to the current instance

        // Window for filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Historial'), align: 'center' }, // Title label
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close window on icon click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable',
                id: 'dtDetails', // DataTable for details
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    {
                        id: 'detailTittle',
                        header: '',
                        width: 50,
                        height: 25,
                        tooltip: 'Detalles', // Tooltip for details icon
                        template: function (obj) {
                            return "<span class='webix_icon wxi-close details'></span>"; // Details icon template
                        },
                    },
                    { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                    {
                        id: 'UserModifId',
                        header: _('UserModifId'), // User modification ID column
                        width: 100,
                        sort: 'int',
                    },
                    { id: 'Date', header: _('Fecha'), width: 100, sort: 'int' }, // Date column
                    { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Type column
                    {
                        id: 'Amount',
                        header: _('Monto'), // Amount column
                        width: 100,
                        sort: 'int',
                    },
                    {
                        id: 'Description',
                        header: _('Descripción'), // Description column
                        width: 100,
                        sort: 'int',
                    },
                ],
                onClick: {
                    details: function (euv, id) {
                        var item = this.getItem(id); // Get clicked item
                        vthis.app.callEvent('withdrawTransDetail:select', [item]); // Trigger event with item
                        $$('detailsCasino').show(); // Show details view
                    },
                },
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                {
                    id: 'detailTittle',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: 'Detalles', // Tooltip for details icon
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close details'></span>"; // Details icon template
                    },
                },
                { id: 'Id', header: 'ID', width: 100, sort: 'int' }, // ID column
                {
                    id: 'UserModifId',
                    header: _('UserModifId'), // User modification ID column
                    width: 100,
                    sort: 'int',
                },
                { id: 'Date', header: _('Fecha'), width: 100, sort: 'int' }, // Date column
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Type column
                { id: 'Amount', header: _('Monto'), width: 100, sort: 'int' }, // Amount column
                {
                    id: 'Description',
                    header: _('Descripción'), // Description column
                    width: 100,
                    sort: 'int',
                },
            ],
            onClick: {
                details: function (euv, id) {
                    var item = this.getItem(id); // Get clicked item
                    this.$scope.app.callEvent('withdrawTransDetail:select', [item]); // Trigger event with item
                },
            },
            loadahead: 0, // Load ahead configuration
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table grid instance.
     */
    init(grid) {
        var url =
            devConfig.geturlApi() + // API base URL
            'es/Client/GetClientWithdrawalRequestsDetail'; // Endpoint for withdrawal requests

        this.on(this.app, 'user:id', (idUser) => {
            grid.clearAll(); // Clear grid data
            grid.load(url + '?id=' + idUser); // Load data for the specific user
            $$('dtDetails').clearAll(); // Clear details data
            $$('dtDetails').load(url + '?id=' + idUser); // Load details for the specific user
        });

        // Event listener for item click in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('withdrawTransDetail:select', [item]); // Trigger event with item
        });
    }
}

// FILE DOCUMENTED
